import { useCallback, useState } from 'react'
import { useTextToSpeech } from 'components/Common/AppTextToSpeech/AppTextToSpeech.component'

export const useVoicePlayback = () => {
  const { isSupported, isLoading, audioUrl, fetchAudio, clearAudio } = useTextToSpeech()

  const [activeKey, setActiveKey] = useState<string | null>(null)

  const togglePlayback = useCallback(
    async (key: string, text: string, languageCode?: string) => {
      if (!isSupported || !text) return

      if (activeKey === key) {
        // Same message — clear to stop (WaveSurfer handles pause internally via UI)
        clearAudio()
        setActiveKey(null)
        return
      }

      // Different message — fetch new audio
      clearAudio()
      setActiveKey(key)
      await fetchAudio(text, languageCode)
    },
    [isSupported, activeKey, clearAudio, fetchAudio]
  )

  const clearPlayback = useCallback(() => {
    clearAudio()
    setActiveKey(null)
  }, [clearAudio])

  return {
    isSupported,
    isLoading,
    activeKey,
    audioUrl,
    togglePlayback,
    clearPlayback,
  }
}
